import 'babel-polyfill'
import * as React from 'react'
import * as ReactDOM from 'react-dom'
import FrontendApp from 'components/FrontendApp'

document.addEventListener('DOMContentLoaded', () => {
    ReactDOM.render(<FrontendApp />, document.getElementById('frontend-app'))
})
